import ProfileInitial from 'atoms/ProfileInitial';
import NextImage from 'next/image';
import React, { useEffect, useState } from 'react';

const Image = ({ src, fallbackSrc = '/assets/images/avatar.svg', alt, showInitial = false, name = 'John', ...rest }) => {

  const [imgSrc, setImgSrc] = useState(src);

  const handleError = () => {
    setImgSrc(fallbackSrc);
  };

  useEffect(() => { setImgSrc(src) }, [src]);

  return (
    (showInitial && !src) ? (
      <ProfileInitial name={name} {...rest} />
    ) : (
      <NextImage
        src={imgSrc}
        alt={alt}
        onError={handleError}
        {...rest}
      />
    )
  );
};

export default Image;
